import React, { useEffect, useState } from "react";
import { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import Button from "../../../../components/Common/Button/Button";
import ContentCard from "../../../../components/Common/ContentCard/ContentCard";
import Input from "../../../../components/Common/Input/Input";
import ListContainer from "../../../../components/Common/ListContainer/ListContainer";
import Loader from "../../../../components/Common/Loader/Loader";
import HtmlBigIcon from "../../../../components/Common/SvgIcons/ShotClassTypeIcons/HtmlBigIcon";
import HtmlIcon from "../../../../components/Common/SvgIcons/ShotClassTypeIcons/HtmlIcon";
import LocalFileBigIcon from "../../../../components/Common/SvgIcons/ShotClassTypeIcons/LocalFileBigIcon";
import LocalFileIcon from "../../../../components/Common/SvgIcons/ShotClassTypeIcons/LocalFileIcon";
import OnlineBigIcon from "../../../../components/Common/SvgIcons/ShotClassTypeIcons/OnlineBigIcon";
import OnlineIcon from "../../../../components/Common/SvgIcons/ShotClassTypeIcons/OnlineIcon";
import ScormBigIcon from "../../../../components/Common/SvgIcons/ShotClassTypeIcons/ScormBigIcon";
import ScormIcon from "../../../../components/Common/SvgIcons/ShotClassTypeIcons/ScormIcon";
import SlideShareBigIcon from "../../../../components/Common/SvgIcons/ShotClassTypeIcons/SlideShareBigIcon";
import SlideShareIcon from "../../../../components/Common/SvgIcons/ShotClassTypeIcons/SlideShareIcon";
import YoutubeBigIcon from "../../../../components/Common/SvgIcons/ShotClassTypeIcons/YoutubeBigIcon";
import YoutubeIcon from "../../../../components/Common/SvgIcons/ShotClassTypeIcons/YoutubeIcon";
import TabLinks from "../../../../components/Common/TabLinks/TabLinks";
import { setErrorHandler } from "../../../../store/actions/actionHandlers/errorActionHandler";
import {
  getOnlineCoursesActionHandler,
  getSlideSharesActionHandler,
  getYoutubeVideosActionHandler,
} from "../../../../store/actions/actionHandlers/manageActionHandler";
import { contentMediaTypes } from "../../../../utils/contentMediaTypes";
import { errorTypes } from "../../../../utils/errorTypes";
import classes from "./AddContent.module.scss";
import { FormattedMessage } from "react-intl";
const AddContent = ({
  handleSelectContent,
  buttonTexts,
  setValue,
  manageTiles,
  setManageTiles,
  contentMediaType,
  contentValue,
  shotclassType,
  createShotclassesPath,
  isDistributed,
  quizQuestionCount,
  surveyQuestionCount,
  isSlideShareFeaturePresent,
  isWebinarSelected,
}) => {
  const dispatch = useDispatch();
  const [youTubeVideos, setYouTubeVideos] = useState([]);
  const [onlineCourses, setOnlineCourses] = useState([]);
  const [slideShares, setSlideShares] = useState([]);
  const [activeTab, setActiveTab] = useState(1);
  const contentFileRef = useRef();
  const [youtube, setYoutube] = useState({
    mode: "url",
    placeholder: "Enter Youtube URL",
    searchValue: "",
    errorMessage: "",
  }); // "url" or "search"

  const manageState = useSelector((state) => state.manageReducer);
  const {
    getYoutubeVideosLoader,
    getOnlineCoursesLoader,
    getSlidesharesLoader,
  } = manageState;

  useEffect(() => {
    if (
      shotclassType === "edit" ||
      shotclassType === "copy"
      //  &&
      // isDistributed
    ) {
      if (
        contentMediaType === 1 ||
        contentMediaType === 3 ||
        contentMediaType === 7
      ) {
        setActiveTab(1);
      } else if (contentMediaType === 2) {
        setActiveTab(2);
      } else if (contentMediaType === 8) {
        setActiveTab(3);
      } else if (contentMediaType === 9) {
        setActiveTab(4);
      } else if (contentMediaType === 5) {
        setActiveTab(5);
      } else if (contentMediaType === 11) {
        setActiveTab(6);
      }
    }
  }, [contentMediaType, shotclassType, isDistributed]);

  let contentTabs = [
    {
      id: 1,
      name: "Local",
      heading: "Upload From Device",
      description: isWebinarSelected
        ? ".avi, .mp4, .mpg, .ppt, .pptx, .pdf, .mov"
        : ".avi, .mp4, .mpg, .ppt, .pptx, .pdf, .mov, .mp3, .m4a",
      icon: (fill) => <LocalFileIcon fill={fill} />,
      bigIcon: <LocalFileBigIcon />,
      accept: ".avi, .mp4, .mpg, .ppt, .pptx, .pdf, .mov, .mp3, .m4a",
      onClick: () => contentFileRef.current.click(),
      disabled:
        // If webinar and distributed, do NOT disable
        !(
          isWebinarSelected &&
          isDistributed &&
          (contentMediaType == 8||
            contentMediaType == 5 ||
            contentMediaType == 9 ||
            contentMediaType == 11)
        ) &&
        (shotclassType === "edit" || shotclassType === "copy") &&
        isDistributed &&
        contentMediaType !== 1 &&
        contentMediaType !== 3 &&
        contentMediaType !== 7,
    },
    {
      id: 2,
      name: "Youtube",
      heading: "Upload From Youtube",
      description: "Enter URL (OR) Search by Keywords ",
      icon: (fill) => <YoutubeIcon fill={fill} />,
      bigIcon: <YoutubeBigIcon />,
      loading: getYoutubeVideosLoader,
      disabled:
        // If webinar and distributed, do NOT disable
        !(
          isWebinarSelected &&
          isDistributed &&
          (contentMediaType == 8 ||
            contentMediaType == 5 ||
            contentMediaType == 9 ||
            contentMediaType == 11)
        ) &&
        (shotclassType === "edit" || shotclassType === "copy") &&
        isDistributed &&
        contentMediaType !== 2,
    },
    {
      id: 3,
      name: "Online Courses",
      heading: "Search From Online",
      description: "Enter keywords and select course",
      icon: (fill) => <OnlineIcon fill={fill} />,
      bigIcon: <OnlineBigIcon />,
      loading: getOnlineCoursesLoader,
      disabled:
        isWebinarSelected ||
        ((shotclassType === "edit" || shotclassType === "copy") &&
          isDistributed &&
          contentMediaType !== 8) ||
        (!contentValue && quizQuestionCount > 0 && surveyQuestionCount > 0) ||
        (!contentValue && quizQuestionCount > 0) ||
        (!contentValue && surveyQuestionCount > 0),
    },
    {
      id: 4,
      name: "SCORM",
      heading: "Upload SCORM",
      description: "SCORM content should be in zip file",
      icon: (fill) => <ScormIcon fill={fill} />,
      bigIcon: <ScormBigIcon />,
      accept: ".zip",
      onClick: () => contentFileRef.current.click(),
      disabled:
        isWebinarSelected ||
        ((shotclassType === "edit" || shotclassType === "copy") &&
          isDistributed &&
          contentMediaType !== 9),
    },
    {
      id: 5,
      name: "Slideshare",
      heading: "Search in Slideshare",
      description: "Enter keywords and select course",
      icon: (fill) => <SlideShareIcon fill={fill} />,
      bigIcon: <SlideShareBigIcon />,
      loading: getSlidesharesLoader,
      disabled:
        isWebinarSelected ||
        ((shotclassType === "edit" || shotclassType === "copy") &&
          isDistributed &&
          contentMediaType !== 5) ||
        !isSlideShareFeaturePresent,
    },
    {
      id: 6,
      name: "HTML5",
      heading: "Upload HTML5",
      description: "HTML5 content should be in zip file",
      icon: (fill) => <HtmlIcon fill={fill} />,
      bigIcon: <HtmlBigIcon />,
      accept: ".zip",
      onClick: () => contentFileRef.current.click(),
      disabled:
        isWebinarSelected ||
        ((shotclassType === "edit" || shotclassType === "copy") &&
          isDistributed &&
          contentMediaType !== 11),
    },
  ];

  const handleActiveTab = (id) => {
    if (id) {
      setActiveTab(id);
    }
    setValue("search1", "");
    setValue("search2", "");
    setYouTubeVideos([]);
    setOnlineCourses([]);
    setSlideShares([]);
    if (id === 2) {
      setYoutube({
        mode: "url",
        placeholder: "Enter Youtube URL",
        searchValue: "",
        errorMessage: "",
      });
    }
  };

  const handleCancel = () => {
    handleActiveTab();
    handleSelectContent();
  };

  const handleUpload = (e, value) => {
    const file = e?.target?.files[0];
    let lastIndexVal = (file?.name.lastIndexOf(".") - 1) >>> 0;
    let fileExtension = file?.name.slice(lastIndexVal + 2);
    let fileSize = Math.round(file?.size / 1024);
    let isValid = true;

    setValue("search1", "");
    setValue("search2", "");

    if (activeTab === 2) {
      let contentValue = [
        {
          ...value,
          name: value.Name,
          link: "https://www.youtube.com/embed/" + value.Id,
        },
      ];
      setValue("Content.ContentValue", contentValue);
      setValue("Content.ContentMediaType", 2);
      setValue("Content.ContentMediaExtension", "");
    } else if (activeTab === 3) {
      // Check if webinar is selected - prevent Online Courses upload
      if (isWebinarSelected) {
        setActiveTab(1); // Switch to Local files tab
        return;
      }
      let contentValue = [
        { ...value, name: value.MoocCourseName, link: value.MoocCourseUrl },
      ];
      setValue("Content.ContentValue", contentValue);
      setValue("Content.ContentMediaType", 8);
      setValue("Content.ContentMediaExtension", "");
      if (!isDistributed) {
        handleSelectContent(buttonTexts.publish);
        let updatedTiles = manageTiles.map((tile) => {
          if (tile.path === `${createShotclassesPath}/addQuiz`) {
            return { ...tile, hidden: true };
          } else if (tile.path === `${createShotclassesPath}/addSurvey`) {
            return { ...tile, hidden: true };
          }
          return tile;
        });
        setManageTiles(updatedTiles);
      } else {
        handleSelectContent();
      }
    } else if (activeTab === 4) {
      // Check if webinar is selected - prevent Online Courses upload
      if (isWebinarSelected) {
        setActiveTab(1); // Switch to Local files tab
        return;
      }
      const filesSupported = ["zip"];
      if (!filesSupported.includes(fileExtension)) {
        dispatch(
          setErrorHandler(errorTypes.WARN, `Please select a valid format`)
        );
        isValid = false;
        return;
      } else {
        setValue("Content.ContentMediaType", 9);
        setValue("Content.ContentMediaExtension", fileExtension);
      }
    } else if (activeTab === 5) {
      // Check if webinar is selected - prevent Online Courses upload
      if (isWebinarSelected) {
        setActiveTab(1); // Switch to Local files tab
        return;
      }
      let contentValue = [
        { ...value, name: value.Name, link: value.SecretKey },
      ];
      setValue("Content.ContentValue", contentValue);
      setValue("Content.ContentMediaType", 5);
      setValue("Content.ContentMediaExtension", "");
    } else if (activeTab === 6) {
      const filesSupported = ["zip"];
      if (!filesSupported.includes(fileExtension)) {
        dispatch(
          setErrorHandler(errorTypes.WARN, `Please select a valid format`)
        );
        isValid = false;
        return;
      } else {
        setValue("Content.ContentMediaType", 11);
        setValue("Content.ContentMediaExtension", fileExtension);
      }
    } else {
      // debugger;
      let selectedMediaType;
      contentMediaTypes.forEach((type) => {
        if (type.extensions.find((val) => val === fileExtension)) {
          selectedMediaType = type.mediaType;
        }
      });
      // Use different supported extensions if isWebinarSelected is true
      const filesSupported = isWebinarSelected
        ? ["avi", "mp4", "mpg", "ppt", "pptx", "pdf", "mov"]
        : ["avi", "mp4", "mpg", "ppt", "pptx", "pdf", "mov", "mp3", "m4a"];

      // Enhanced validation logic for distributed classes
      const isValidFileExtension = filesSupported.includes(fileExtension);

      // For distributed classes during copy operations, allow content type changes
      const isCopyOperation = shotclassType === "copy";
      const isEditOperation = shotclassType === "edit";
      // Only validate against original contentMediaType for edit operations of distributed classes
      // For copy operations, allow any valid format regardless of original content type
      const shouldValidateAgainstOriginalContentType =
        isDistributed && isEditOperation && !isCopyOperation;
      // Updated logic: Only apply distributed check for 4,5,9,11, otherwise go inside and check
      if (
        !filesSupported.includes(fileExtension) ||
        (
          isDistributed &&
          !(contentMediaType == 8 ||
            contentMediaType == 5 ||
            contentMediaType == 9 ||
            contentMediaType == 11) &&
          selectedMediaType !== contentMediaType
        )
      ) {
        dispatch(
          setErrorHandler(errorTypes.WARN, `Please select a valid format`)
        );
        setValue("Content.ContentValue", "");
        isValid = false;
        return;
      } else if (
        !isValidFileExtension ||
        (shouldValidateAgainstOriginalContentType &&
          selectedMediaType !== contentMediaType)
      ) {
        let errorMessage = "Please select a valid format";

        if (!isValidFileExtension) {
          errorMessage = isWebinarSelected
            ? "For webinar classes, supported formats are: AVI, MP4, MPG, PPT, PPTX, PDF, MOV"
            : "Supported formats are: AVI, MP4, MPG, PPT, PPTX, PDF, MOV, MP3, M4A";
        } else if (shouldValidateAgainstOriginalContentType) {
          errorMessage =
            "For distributed classes in edit mode, content type must match the original content type";
        }

        dispatch(setErrorHandler(errorTypes.WARN, errorMessage));
        setValue("Content.ContentValue", "");
        isValid = false;
        return;
      } else {
        if (fileExtension === "pdf") {
          if (fileSize > 10240) {
            dispatch(
              setErrorHandler(
                errorTypes.WARN,
                "Selected PDF Size must not exceed 10MB"
              )
            );
            setValue("Content.ContentValue", "");
            return;
          }
        } else if (fileExtension === "ppt" || fileExtension === "pptx") {
          if (fileSize > 10240) {
            dispatch(
              setErrorHandler(
                errorTypes.WARN,
                "Selected PPT Size must not exceed 10MB"
              )
            );
            setValue("Content.ContentValue", "");
            return;
          }
        }
        setValue("Content.ContentMediaType", selectedMediaType);
        setValue("Content.ContentMediaExtension", fileExtension);
      }
    }
    if (activeTab !== 3) {
      if (!isDistributed) {
        handleSelectContent(buttonTexts.addQuiz);
      } else if (isValid) {
        handleSelectContent();
      }
    }
  };
  // Add this useEffect to handle automatic tab switching when webinar is selected
  useEffect(() => {
    // If webinar is selected and user is on a restricted tab, switch to allowed tab
    if (isWebinarSelected && [3, 4, 5, 6].includes(activeTab)) {
      setActiveTab(1); // Switch to Local files tab
      // dispatch(
      //   setErrorHandler(
      //     errorTypes.WARN,
      //     "For a Webinar type please upload – Video (AVI, MP4, MPG, MOV), YouTube, or Documents (PPT, PPTX, PDF)"
      //   )
      // );
    }
  }, [isWebinarSelected, activeTab, dispatch]);
  const handleYoutubeRadioChange = (e) => {
    setYoutube({
      searchValue: "",
      errorMessage: "",
      mode: e.target.value,
      placeholder:
        e.target.value === "url"
          ? "Enter Youtube URL"
          : "Search YouTube Videos by Keywords",
    });
    setYouTubeVideos([]);
  };

  function isValidYoutubeUrl(url) {
    const pattern = /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.be)\/.+$/;
    return pattern.test(url);
  }

  return (
    <div className={classes.addContent}>
      <div className={classes.addContent__header}>
        <div className={classes.addContent__header__heading}>
          Upload Content
        </div>
        <TabLinks
          tabs={contentTabs}
          activeTab={activeTab}
          setActiveTab={handleActiveTab}
          gap={3}
        />
      </div>
      <div className={classes.addContent__main}>
        {activeTab === 2 ? (
          // <div className={classes.addContent__main__search}>
          //   <Input
          //     label={<FormattedMessage id="P_Search" />}
          //     name="search1"
          //     placeholder="Search Video"
          //     labelColor="dark"
          //     search={true}
          //     borderRadius={0.8}
          //     height={5}
          //     width={32}
          //     // onChange={(e) => {
          //     //   if (e.key === "Enter") {
          //     //     e.preventDefault();
          //     //   }
          //     //   if (e.target.value.trim() !== "") {
          //     //     dispatch(
          //     //       getYoutubeVideosActionHandler(
          //     //         e.target.value,
          //     //         setYouTubeVideos
          //     //       )
          //     //     );
          //     //   } else {
          //     //     setYouTubeVideos([]);
          //     //   }
          //     // }}
          //     // onChange={(e) => {
          //     //   debouncedYoutubeSearch(e.target.value);
          //     // }}
          //     onKeyDown={(e) => {
          //       if (e.keyCode === 13 && e.target.value.trim() !== "") {
          //         e.preventDefault();
          //         dispatch(
          //           getYoutubeVideosActionHandler(
          //             e.target.value,
          //             setYouTubeVideos
          //           )
          //         );
          //       } else setYouTubeVideos([]);
          //     }}
          //   />
          //   <span className={classes.addContent__main__search__OR}>(OR)</span>
          //   <Input
          //     label="URL"
          //     name="search2"
          //     placeholder="Enter URL"
          //     labelColor="dark"
          //     search={true}
          //     borderRadius={0.8}
          //     height={5}
          //     width={32}
          //     onChange={(e) => {
          //       if (e.key === "Enter") {
          //         e.preventDefault();
          //       }
          //       if (e.target.value.trim() !== "") {
          //         dispatch(
          //           getYoutubeVideosActionHandler(
          //             e.target.value,
          //             setYouTubeVideos
          //           )
          //         );
          //       } else {
          //         setYouTubeVideos([]);
          //       }
          //     }}
          //     onKeyDown={(e) => {
          //       if (e.key === "Enter") {
          //         e.preventDefault();
          //       }
          //     }}
          //   />
          // </div>
          <div className={classes.addContent__main__youtube}>
            <div className={classes.addContent__main__youtube__youtubeSearch}>
              <div
                className={
                  classes.addContent__main__youtube__youtubeSearch__radio
                }
              >
                <div
                  className={
                    classes.addContent__main__youtube__youtubeSearch__radio__btn
                  }
                >
                  <input
                    type="radio"
                    id="url"
                    name="youtube"
                    value="url"
                    checked={youtube.mode === "url"}
                    onChange={handleYoutubeRadioChange}
                  />
                  &nbsp;
                  <label htmlFor="url">URL</label>
                </div>
                <div
                  className={
                    classes.addContent__main__youtube__youtubeSearch__radio__btn
                  }
                >
                  <input
                    type="radio"
                    id="search"
                    name="youtube"
                    value="search"
                    onChange={handleYoutubeRadioChange}
                  />
                  &nbsp;
                  <label htmlFor="search">Keywords</label>
                </div>
              </div>
              <input
                type="text"
                name="search1"
                placeholder={youtube.placeholder}
                className={
                  classes.addContent__main__youtube__youtubeSearch__input
                }
                value={youtube.searchValue}
                autoComplete="off"
                onChange={(e) => {
                  const value = e.target.value;
                  setYoutube({
                    ...youtube,
                    searchValue: value,
                    errorMessage:
                      value === "" ||
                      isValidYoutubeUrl(value) ||
                      youtube.mode === "search"
                        ? ""
                        : "Please enter a valid YouTube URL",
                  });
                }}
              />

              {youtube.errorMessage && youtube.mode === "url" && (
                <span className={classes.addContent__main__youtube__error}>
                  {youtube.errorMessage}
                </span>
              )}
            </div>
            <Button
              label="Search"
              small
              dark
              type="button"
              disabled={
                youtube.errorMessage !== "" || youtube.searchValue.trim() === ""
              }
              onClick={() => {
                if (youtube.searchValue.trim() !== "") {
                  dispatch(
                    getYoutubeVideosActionHandler(
                      youtube.searchValue,
                      setYouTubeVideos
                    )
                  );
                } else setYouTubeVideos([]);
              }}
            />
          </div>
        ) : activeTab === 3 ? (
          <div className={classes.addContent__main__search}>
            <Input
              name="search1"
              placeholder="Enter Keyword"
              search={true}
              borderRadius={0.8}
              height={5}
              width={32}
              onChange={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                }
                if (e.target.value.trim() !== "") {
                  dispatch(
                    getOnlineCoursesActionHandler(
                      e.target.value,
                      setOnlineCourses
                    )
                  );
                } else {
                  setOnlineCourses([]);
                }
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                }
              }}
            />
          </div>
        ) : activeTab === 5 ? (
          <div className={classes.addContent__main__search}>
            <Input
              name="search1"
              placeholder="Enter Keyword"
              search={true}
              borderRadius={0.8}
              height={5}
              width={32}
              onChange={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                }
                if (e.target.value.trim() !== "") {
                  dispatch(
                    getSlideSharesActionHandler(e.target.value, setSlideShares)
                  );
                } else {
                  setSlideShares([]);
                }
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                }
              }}
            />
          </div>
        ) : (
          <></>
        )}
        {contentTabs.map((tab) => {
          return tab.id === activeTab ? (
            activeTab === 2 && youTubeVideos?.length > 0 && !tab.loading ? (
              <ListContainer
                height="30rem"
                columns="4"
                columnWidth="1fr"
                rowGap="2rem"
                columnGap="2.5rem"
                key={tab.id}
              >
                {youTubeVideos.map((val, index) => {
                  return (
                    <ContentCard
                      src={"https://www.youtube.com/embed/" + val.Id}
                      type="youtube"
                      title={val.Name}
                      key={val.Id}
                      value={val}
                      index={index}
                      handleChange={handleUpload}
                      setValue={setValue}
                    />
                  );
                })}
              </ListContainer>
            ) : activeTab === 3 && onlineCourses?.length > 0 && !tab.loading ? (
              <ListContainer
                height="30rem"
                columns="4"
                columnWidth="1fr"
                rowGap="2rem"
                columnGap="2.5rem"
                key={tab.id}
              >
                {onlineCourses.map((val, index) => {
                  return (
                    <ContentCard
                      src={val.MoocCourseThumbnailUrl}
                      type="mooc"
                      title={val.MoocCourseName}
                      key={val.MoocCourseId}
                      value={val}
                      index={index}
                      handleChange={handleUpload}
                      setValue={setValue}
                    />
                  );
                })}
              </ListContainer>
            ) : activeTab === 5 && slideShares?.length > 0 && !tab.loading ? (
              <ListContainer
                height="30rem"
                columns="4"
                columnWidth="1fr"
                rowGap="2rem"
                columnGap="2.5rem"
                key={tab.id}
              >
                {slideShares?.map((val, index) => {
                  return (
                    <ContentCard
                      src={val.SecretKey}
                      type="slideshare"
                      title={val.Name}
                      key={val.MoocCourseId}
                      value={val}
                      index={index}
                      handleChange={handleUpload}
                      setValue={setValue}
                    />
                  );
                })}
              </ListContainer>
            ) : (
              <div
                key={tab.id}
                className={classes.addContent__main__uploadContainer}
                onClick={() => tab?.onClick && tab?.onClick()}
              >
                <Input
                  type="file"
                  name="Content.ContentValue"
                  hidden={true}
                  reference={contentFileRef}
                  accept={tab?.accept}
                  fileInputButton={false}
                  fileInputName="false"
                  onChange={(e) => handleUpload(e)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                    }
                  }}
                />
                {tab.loading ? <Loader height={30} width={30} /> : tab.bigIcon}
                <div
                  className={classes.addContent__main__uploadContainer__heading}
                >
                  {tab.heading}
                </div>
                <div
                  className={
                    classes.addContent__main__uploadContainer__description
                  }
                >
                  {tab.description}
                </div>
              </div>
            )
          ) : (
            <React.Fragment key={tab.id}></React.Fragment>
          );
        })}
      </div>
      <div>
        <div className={classes.addContent__footer}>
          <Button
            label={<FormattedMessage id="USERGROUP_CANCELBTN" />}
            small
            dark
            type="button"
            onClick={() => handleCancel()}
          />
        </div>
      </div>
    </div>
  );
};

export default AddContent;
